export default {
    listagem: {
        titulo_pagina: 'List of Times',
        novo: 'Create New Time',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Time Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Time',
            editar: 'Edit Time'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Time Code'
            },
            nome: {
                label: 'Name',
                description: 'Time Name'
            },
            status: {
                label: 'Status',
                description: 'Time active or inactive status'
            },
            botao_salvar : 'Save Time'
        },
        create: {
            success: 'Time successfully created!',
            error: 'Error creating time!'
        },
        update: {
            success: 'Time successfully edited!',
            error: 'Error editing time!'
        }
    }
}
